import React, { useState } from 'react';
import { Button } from '@components/ui/button';
import { Input } from '@components/ui/input';
import { Card } from '@components/ui/card';

const POPULAR_CHOICES = [
  'Data Science & Machine Learning',
  'Web Development',
  'Mathematics',
  'Physics',
  'Chemistry',
  'Biology',
  'Economics',
  'Political Science',
  'Computer Science',
  'Art & Design',
  'Philosophy',
  'Psychology',
  'Foreign Languages',
  'Business & Entrepreneurship',
];

const LearningGoalStep = ({ onNext, onBack, formData, canGoBack }) => {
  const [learningGoal, setLearningGoal] = useState(formData.learningGoal || '');
  const [customInput, setCustomInput] = useState(formData.learningGoal || '');

  const handleCardClick = (goal) => {
    setLearningGoal(goal);
    setCustomInput(goal);
  };

  const handleContinue = () => {
    onNext({ learningGoal: customInput });
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">What do you want to learn?</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          This will help us tailor your learning experience. Be as specific or general as you like.
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">Learning goal</label>
          <Input
            placeholder="e.g., Quantum Physics, Spanish, History of Art..."
            value={customInput}
            onChange={(e) => setCustomInput(e.target.value)}
            className="text-lg p-4 bg-secondary border-border"
          />
        </div>

        <div>
          <p className="text-sm font-medium text-muted-foreground mb-4">Popular choices</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {POPULAR_CHOICES.map((choice) => (
              <Card
                key={choice}
                className={`p-4 cursor-pointer transition-all hover:bg-secondary/80 ${
                  learningGoal === choice ? 'bg-primary/10 border-primary' : 'bg-secondary border-border'
                }`}
                onClick={() => handleCardClick(choice)}>
                <p className="text-sm font-medium text-foreground">{choice}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-between pt-8">
        {canGoBack && (
          <Button variant="outline" onClick={onBack} className="px-8">
            Back
          </Button>
        )}
        <Button onClick={handleContinue} disabled={!customInput.trim()} className="px-8 ml-auto">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default LearningGoalStep;
